import { writable } from 'svelte/store'

import { makeItem } from './factories'



const store = writable(makeItem())

export { store as item_store }



